import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { useJoinIntention } from '../intentionModel'
import { FranchiseePageResult } from '../intentionService'
import { globalPrompt } from '@/components/message'
import useNavModel from '@/model/navModel'
import YhTootip from '@/components/YhTootip'
import { useDictModel } from '@/views/base/dict/dictModel'
import { ColumnsType } from 'antd/lib/table'

export function DataTable() {
    const {
        dataSource,
        selectedRowKeys,
        pgCfg,
        loadData,
        setSelectedRowKeys,
        updateEditFormVal,
        setChoosedId,
        setContractVisible,
        setChoosedFranchiseeId,
        setFollowUpRecordsVisible,
    } = useJoinIntention()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])
    const { getTreeNodeName } = useDictModel()
    useEffect(() => {
        loadData()
    }, [])
    const onEdit = (record) => {
        let supplierEditKey = '2-1-2'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: record?.id, mode: 'edit' })
            updateEditFormVal(null)
        } else {
            globalPrompt('modal', {
                title: '意向加盟跳转详情',
                type: 'warning',
                text: '您还有意向加盟详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: record?.id, mode: 'edit' })
                    updateEditFormVal(null)
                },
            })
        }
    }

    const defaultColumns: ColumnsType<FranchiseePageResult> = [
        {
            title: '序号',
            width: 80,
            fixed: 'left',
            render: (t, r, i) => i + 1,
            align: 'center',
        },
        {
            title: '操作',
            width: 120,
            fixed: 'left',
            render: (t, r) => (
                <>
                    <span
                        style={{ color: '#4165E3', cursor: 'pointer' }}
                        onClick={() => {
                            onEdit(r)
                        }}
                    >
                        编辑
                    </span>
                    <span
                        style={{ color: '#4165E3', cursor: 'pointer', marginLeft: '20px' }}
                        onClick={() => {
                            setContractVisible(true)
                            setChoosedId(r.id)
                        }}
                    >
                        签约
                    </span>
                </>
            ),
        },
        {
            title: '加盟商编号',
            width: 140,
            dataIndex: 'code',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '加盟商名称',
            width: 140,
            dataIndex: 'name',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '负责人',
            width: 140,
            dataIndex: 'contact',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '电话',
            width: 140,
            dataIndex: 'phone',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '地址',
            width: 140,
            dataIndex: 'address',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '经营性质',
            width: 100,
            dataIndex: 'businessNature',
            render: (text) => <YhTootip text={getTreeNodeName(text)} style={{ width: '100px' }} />,
        },
        {
            title: '资质',
            width: 110,
            dataIndex: 'qualification',
            render: (text) => <YhTootip text={getTreeNodeName(text)} style={{ width: '110px' }} />,
        },
        {
            title: '加盟意向',
            width: 110,
            dataIndex: 'followUpList',
            render: (text) => <YhTootip text={text?.length > 0 ? getTreeNodeName(text[text.length - 1].intentionLevel) : ''} style={{ width: '110px' }} />,
        },
        {
            title: '跟进次数',
            width: 110,
            dataIndex: 'followUpList',

            render: (text, r) => (
                <span
                    onClick={() => {
                        setChoosedFranchiseeId(r.id as string)
                        setFollowUpRecordsVisible(true)
                    }}
                    style={{ color: '#4165E3', cursor: 'pointer' }}
                >
                    {text?.length ?? 0}
                </span>
            ),
        },
        {
            title: '跟进内容',
            width: 110,
            dataIndex: 'followUpList',
            render: (text) => <YhTootip text={text?.length > 0 ? text[text.length - 1].followUpContent : ''} style={{ width: '110px' }} />,
        },
        {
            title: '业务经理',
            width: 110,
            dataIndex: 'businessManager',
            render: (text) => <YhTootip text={text} style={{ width: '110px' }} />,
        },
        {
            title: '人员储备',
            width: 110,
            dataIndex: 'personnelReserves',
            render: (text) => <YhTootip text={getTreeNodeName(text)} style={{ width: '110px' }} />,
        },
        {
            title: '公司规模',
            width: 110,
            dataIndex: 'companySize',
            render: (text) => <YhTootip text={text} style={{ width: '110px' }} />,
        },
        {
            title: '加盟类型',
            width: 110,
            dataIndex: 'franchiseType',
            render: (text) => <YhTootip text={getTreeNodeName(text)} style={{ width: '110px' }} />,
        },
        {
            title: '加盟设备',
            width: 110,
            dataIndex: 'franchiseEquipment',
            render: (text) => <YhTootip text={getTreeNodeName(text)} style={{ width: '110px' }} />,
        },
        {
            title: '主要配置',
            width: 110,
            dataIndex: 'mainConfig',
            render: (text) => <YhTootip text={text} style={{ width: '110px' }} />,
        },
    ]

    //点击行选高亮
    const onRow = (record: FranchiseePageResult) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                columns={defaultColumns}
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => onRow(record),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record])
                    },
                })}
            />
        </>
    )
}
